import { Subject } from "rxjs";

const BrochureSummarySubject = new Subject();

const BrochureSummaryService = {
  listen: () => BrochureSummarySubject.asObservable(),
  fetchBrochureSummaryData: () => BrochureSummarySubject.next(),
};

export default BrochureSummaryService;
